import { Container } from "backpack-ui";
import * as React from "react";
import { Link, Route } from "react-router-dom";
export default (function (_a) {
    var match = _a.match, lists = _a.lists;
    return (React.createElement("div", null,
        React.createElement(Container, null,
            React.createElement("h1", null, "Bookmarks!"),
            JSON.stringify(lists),
            React.createElement("ul", null,
                React.createElement("li", null,
                    React.createElement(Link, { to: "/usa/nashville/a/poi-sig/1234" }, "Nashville POIs")),
                React.createElement("li", null,
                    React.createElement(Link, { to: "/profile/" + match.params.username + "/lists/more" }, "More"))),
            React.createElement(Route, { path: "/profile/" + match.params.username + "/lists/more", render: function () { return (React.createElement("h3", null, "More")); } }))));
});



//////////////////
// WEBPACK FOOTER
// ./app/modules/bookmarks/index.tsx
// module id = GpE5
// module chunks = 2